import { ExpenseCreateForm } from "../components/ExpensesCreateForm";
export const NewExpenses = () => {
  return <ExpenseCreateForm />;
};
